import { createApp } from 'vue'
import App from './index.vue'
import * as Sentry from '@sentry/vue'
import env from '@/functions/env'
function toast(text) {
    alert(text)
}
const win: any = window
win.toast = toast

const app = createApp(App)
Sentry.init({
    app,
    dsn: 'https://6b93b3999d530bf2df1eb2191ee1ac79@sentry.baijiayun.com/11',
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration()
    ],
    debug: false,
    environment: env(),
    release: 'v2.15.0_' + env(),

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for tracing.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,

    // 这里设置的是C端的域名
    tracePropagationTargets: [/^https:\/\/[a-zA-Z0-9_-]+\.dxb\.baijiayun\.com/],

    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0
})
app.mount('#app')
